// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1___03cb4c98a140a7df274","cls2":"Base-cls2___0bb2ead8b0af4954f00 Base-cls1___03cb4c98a140a7df274"};